import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'

const resource = 'elearningPathAssignments'

const filter = (axios: IFactoryFunctionRequest<any, any>) => (query: Record<string, any>) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query,
  })
}

const getOne = (axios: IFactoryFunctionRequest<any, any>) => (assignmentId: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${assignmentId}`,
  })
}

const createOne = (axios: IFactoryFunctionRequest<any, any>) => (data: Record<string, any>) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
    data,
  })
}

const patchOne = (axios: IFactoryFunctionRequest<any, any>) => (assignmentId: string, data: Record<string, any>) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${assignmentId}`,
    data,
  })
}

export default (axios: AxiosInstance) => ({
  filter: filter(useAxios(axios)),
  getOne: getOne(useAxios(axios)),
  createOne: createOne(useAxios(axios)),
  patchOne: patchOne(useAxios(axios)),
})
